import * as React from 'react';
import { Amount as AmountBusinessLogic } from 'nomst/Stores/Decision/amount';
import { Input, FormGroup } from '@payscale/design';
import './amountBonusFieldRule.scss';

export interface IAmountBonusFieldRuleProps {
    bonusFieldRule: IBonusFieldRule;
    amount: AmountBusinessLogic;
}

export interface IAmountBonusFieldRuleState {
    splitInput: number;
    attainedInput: number;
}

export class AmountBonusFieldRule extends React.Component<IAmountBonusFieldRuleProps, IAmountBonusFieldRuleState> {

    constructor(props: IAmountBonusFieldRuleProps) {
        super(props);

        this.handleSplitChange = this.handleSplitChange.bind(this);
        this.handleAttainedChange = this.handleAttainedChange.bind(this);
    }

    componentDidMount(): void {
        const { split, attained } = this.props.bonusFieldRule;
        this.setState({ splitInput: split, attainedInput: attained });
    }

    render(): React.ReactNode {
        const { bonusFieldRule, amount } = this.props;
        return (
            <div className="bonus-field-rule">
                <FormGroup
                    className="row"
                    labelClassName="col-sm-12"
                    text={bonusFieldRule.fieldName}
                >
                    <Input
                        className="bonus-field-rule__split col-sm-4"
                        value={this.state.splitInput.toString()}
                        onChange={this.handleSplitChange}
                    />
                    <Input
                        className="bonus-field-rule__attained col-sm-4"
                        value={this.state.attainedInput.toString()}
                        onChange={this.handleAttainedChange}
                    />
                    <p className="bonus-field-rule__amount col-sm-4">{amount.getBonusFactorAmount(bonusFieldRule)}</p>
                </FormGroup>
            </div>
        );
    }

    private handleSplitChange(_: undefined, value: number): void {
        this.props.amount.setSplit(value, this.props.bonusFieldRule);
        this.setState({ splitInput: value });
    }

    private handleAttainedChange(_: undefined, value: number): void {
        this.props.amount.setAttained(value, this.props.bonusFieldRule);
        this.setState({ attainedInput: value });
    }
}